<template>
  <hel-module title="核心指标" :class="scope.clsPrefix" v-loading="loading">
    <div class="indicators-container">
      <div :class="['indicator-item']" v-for="(item, index) in indicators" :key="index">
        <div class="indicator-header">
          <span class="indicator-name">{{ item.name }}</span>
          <!-- <span :class="['indicator-trend', item.trendClass]">
            <span class="trend-value">{{ item.trendValue }}</span>
            <span class="trend-icon">{{ item.trendIcon }}</span>
          </span> -->
        </div>
        <div class="indicator-value">
          <span class="value-num">{{ item.value }}</span>
          <span class="value-unit">{{ item.unit }}</span>
        </div>
      </div>
    </div>
  </hel-module>
</template>

<script>
import HelModule from './common/module/index.vue'
import axios from 'axios'
import { getToken } from '@/utils/auth'
export default {
  name: 'KpiIndicators',
  components: {
    HelModule
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-kpi-indicators'
      },
      indicators: []
    }
  },
  created() {},
  mounted() {
    this.fetchKpiMetrics()
  },
  methods: {
    // 数值加千分位（至多保留两位小数）
    formatNumber(value) {
      const num = Number(value)
      if (value === null || value === undefined || value === '' || Number.isNaN(num)) {
        return '--'
      }
      return num.toLocaleString('zh-CN', { maximumFractionDigits: 2 })
    },
    async fetchKpiMetrics() {
      this.loading = true
      try {
        const response = await axios.get(
          '/energy-api/kx/ceo/data',
          {
            headers: {
              token: getToken()
            }
          }
        )
        const res = response.data || {}
        const data = res.data || {}

        this.indicators = [
          { name: '绿电占比', value: this.formatNumber(data.greenElecRatio), unit: '%' },
          { name: '尖峰用电占比', value: this.formatNumber(data.sharpPeakRatio), unit: '%' },
          { name: '月度电费', value: this.formatNumber(data.monthlyElecCost), unit: '元' },
          { name: '月均电价', value: this.formatNumber(data.avgElecPrice), unit: '元' }
        ]
      } catch (error) {
        console.error('获取核心指标失败:', error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$class-prefix: "rvc-cosmoplat-workspace-kpi-indicators";
.#{$class-prefix} {
  .indicators-container {
    display: grid;
    // flex-wrap: nowrap;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    height: 100%;
    padding: 10px 0;
  }
  .indicator-item {
    flex: 1;
    // width: calc(100% / 7);
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    background: #EFF2FC;
    // height: 106px;
    height: 90px;
    // align-items: center;
    justify-content: space-between;
    padding: 16px 16px;
    // border-right: 1px solid #f0f0f0;
    // &:last-child {
    //   border-right: none;
    // }
    .indicator-header {
      display: flex;
      flex-direction: column;
      // align-items: center;
      // justify-content: center;
      gap: 2px;
      margin-bottom: 8px;
    }
    .indicator-name {
      font-size: 12px;
      font-family: PingFangSC-Medium;
      font-weight: 600;
      font-size: 12px;
      color: #333333;
      margin-bottom: 4px;
    }
    .indicator-trend {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 12px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      // opacity: 0;
      // display: none;
      &.trend-up {
        color: #73B950;
      }
      &.trend-down {
        color: #F44F4F;
      }
      &.trend-flat {
        color: #F4B13D;
      }
    }
    .trend-icon {
      font-size: 12px;
      font-weight: 900;
    }
    .trend-value {
      font-weight: 500;
    }
    .indicator-value {
      display: flex;
      align-items: baseline;
      gap: 8px;
    }
    .value-num {
      font-size: 24px;
      font-weight: 700;
      font-family: PingFangSC-Semibold;
      color: #333;
      line-height: 32px;
    }
    .value-unit {
      font-size: 12px;
      color: #333;
      font-weight: 400;
    }
    &.is-highlight .value-num {
      color: #F44F4F;
    }
  }
}
@media screen and (max-width: 1440px) {
  .#{$class-prefix} {
    .indicator-item {
      .value-num {
        font-size: 18px;
      }
      .indicator-name {
        font-size: 11px;
      }
    }
  }
}
</style>
